var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9352 5.34658C13.5553 5.34658 13.2473 5.65458 13.2473 6.03449V11.8747C13.2473 12.8394 12.4625 13.6242 11.4979 13.6242H3.16043C2.19575 13.6242 1.41098 12.8394 1.41098 11.8747V3.60501C1.41098 2.64038 2.19579 1.85556 3.16043 1.85556H9.1951C9.57501 1.85556 9.88301 1.54756 9.88301 1.16765C9.88301 0.787737 9.57501 0.479736 9.1951 0.479736H3.16043C1.43712 0.479736 0.0351562 1.88175 0.0351562 3.60501V11.8747C0.0351562 13.5979 1.43716 15 3.16043 15H11.4978C13.2211 15 14.6231 13.5979 14.6231 11.8747V6.03449C14.6231 5.65458 14.3151 5.34658 13.9352 5.34658Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.5d3394842d5665de02fdda959134d6f1.svg";
export { ForwardRef as ReactComponent };